"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UserIsNotClassTeacherError extends client_library_1.ExtendableError {
    constructor() {
        super('User is not teacher of all classes');
    }
}
exports.default = UserIsNotClassTeacherError;
//# sourceMappingURL=UserIsNotClassTeacherError.js.map